import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Box, Divider, Switch, Typography } from '@material-ui/core'

import { AutoBlockExplanation } from './components'

import constants from 'constants/index'
import useStyles from './styles'

const AutoBlockSettings = () => {
  const { control } = useFormContext()

  const classes = useStyles()

  const { AUTO_BLOCK_SWITCHES } = constants.cookies.category

  return (
    <>
      <Box p={2} className={classes.switches}>
        {AUTO_BLOCK_SWITCHES.map((autoBlockSwitch) => (
          <Box key={autoBlockSwitch.name} className={classes.mainRow}>
            <Box>
              <Typography
                component="label"
                htmlFor={autoBlockSwitch.name}
                className={classes.mainLabel}
              >
                {autoBlockSwitch.label}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {autoBlockSwitch.description}
              </Typography>
            </Box>
            <Controller
              control={control}
              name={autoBlockSwitch.name}
              valueName="checked"
              onChange={([, checked]) => checked}
              as={
                <Switch
                  id={autoBlockSwitch.name}
                  edge="end"
                  color="default"
                  classes={{
                    switchBase: classes.switchBase,
                    checked: classes.checked,
                    track: classes.track,
                  }}
                />
              }
            />
          </Box>
        ))}
      </Box>
      <Divider />
      <AutoBlockExplanation />
    </>
  )
}

export default AutoBlockSettings
